import styles from "./Skills.module.scss";

export const Skills = () => (
  <div className={styles.skills}>
    <div className={styles.title}>Владею</div>
    <p>&#45; JavaScript</p>
    <p>&#45; React</p>
    <p>&#45; Redux</p>
    <p>&#45; TypeScript</p>
    <p>&#45; HTML</p>
    <p>&#45; CSS</p>
    <p>&#45; Git</p>
    <p>&#45; MUI</p>
    <p>&#45; MODX</p>
    <p>&#45; SEO</p>
    <p>&#45; Адаптивная верстка</p>
    <p>&#45; Основы UI/UX</p>
    <p>&#45; Figma</p>
    <p>&#45; Photoshop</p>
  </div>
);
